export default __webpack_public_path__ + "static/media/mahebeach02.5f14c7e7.jpg";